import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import InfoIcon from 'assets/images/icons/encircled-info.svg';
import './FeeWarningToolTipV2.scss';

export function FeeWarningToolTipV2({ facility, className }) {
	const fees = [
		{
			name: 'One-Time Admin Fee',
			price: facility.adminFee,
		},
		{
			name: 'One-Time Lock Fee',
			price: facility.lockFee,
		},
	];
	const totalFees = facility.totalFees;

	return (
		<Tooltip
			className={classnames('tooltip-banner', className)}
			content={
				<div className="ss-type ss-type-tiny ss-type-gray">
					The following fees shall apply:
					<ul>
						{fees.map(
							(fee) =>
								fee.price > 0 && (
									<li
										key={fee.name}
										className="fee-item"
									>
										{`${fee.name}: $${fee.price}`}
									</li>
								),
						)}
					</ul>
				</div>
			}
		>
			<Text
				last
				size="tiny"
				color="gray"
				className="fee-warning-tooltip-v2-text"
			>
				<img
					src={InfoIcon}
					alt="Info"
					className="info-icon"
				/>{' '}
				{totalFees} in fees
			</Text>
		</Tooltip>
	);
}

FeeWarningToolTipV2.propTypes = {
	facility: PropTypes.shape({
		adminFee: PropTypes.number,
		lockFee: PropTypes.number,
		totalFees: PropTypes.number,
	}).isRequired,
	className: PropTypes.string,
};

export default FeeWarningToolTipV2;
